import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { UserSessionService } from '../../../../_client-service/user-session.service';
import { User } from '../../../../model/user';
import { Corso } from '../../../../model/corso';
import { AuthenticationService } from '../../../../service/authentication.service';
import { CourseService } from '../../../../service/course.service';
import { MenuService } from '../../../../_client-service/menu/menu.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {

    user: User;
    corsi: Array<Corso>;
    activeRouter: string;
    selectedMenu: string;
    selectedSubMenu: string;

    constructor(
        private router: Router,
        private userSessionSrv: UserSessionService,
        private menuSrv: MenuService,
        private courseSrv: CourseService,
        private authSrv: AuthenticationService) {
            router.events.subscribe(val => {
            if (val instanceof NavigationEnd) {
                this.manageActiveRouter(val.urlAfterRedirects);
            }
        });
        }

    ngOnInit() {
        this.selectedMenu = 'dashboard';
        this.selectedSubMenu = '';
        // this.user = this.userSessionSrv.getUser();
        this.loadCorsi();
    }

    toggleMenu() {
        this.menuSrv.setMenuStatus('');
    }

    logout() {
        this.authSrv.logout()
        .pipe(first())
        .subscribe(
            data => {
                this.userSessionSrv.setUser(null);
                return;
            },
            error => {
                return;
            }
        );
    }

    private loadCorsi() {
        this.courseSrv.getCoursesByUser()
        .pipe(first())
            .subscribe(
                data => {
                    this.corsi = data;
                },
                error => {
                    return;
                }
            );
    }

    private manageActiveRouter(url: string) {
        if (url.indexOf('p/dashboard') > -1) {
            this.activeRouter = 'DASHBOARD';
        } else if (url.indexOf('p/profilo') > -1 || url.indexOf('p/cambio-password') > -1) {
            this.activeRouter = 'PROFILO';
        } else if (url.indexOf('p/corso') > -1) {
            this.activeRouter = 'CORSO';
        } else if (url.indexOf('p/esercitazioni') > -1) {
            this.activeRouter = 'ESERCITAZIONE';
        } else {
            this.activeRouter = '';
        }
    }

}
